import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { EventsListComponent } from './events/events-list/events-list.component';
import { JitsiContaineComponent } from './job/jitsi-container/jitsi-container';
import { CandidateListComponent } from './job/candidate-list/candidate-list.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { EmailTemplateComponent } from './email/email-template/email-template.component';
import { RoleListComponent } from './roles/role-list/role-list.component';
import { GeneralSettingsComponent } from './settings/general-settings/general-settings.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './route-guard/auth.guard';
import { LoginGuard } from './route-guard/login.guard';
import { TalentpoolManagementComponent } from './talentpool/talentpool-management/talentpool-management.component';
import { CandidatePanelComponent } from './candidate-panel/candidate-panel.component';
import { OtpVerificationComponent } from './job/otp-verification/otp-verification.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FormsListComponent } from './form-builder/form-list/form-list.component';
import { FormCreationComponent } from './form-builder/form-creation/form-creation.component';
import { FormPreviewComponent } from './form-builder/form-preview/form-preview.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FeedbackFormComponent } from './forms/feedback-form/feedback-form.component';
import { LoginCallbackComponent } from './login-call-back/login-callback.component';
import { JobDetailsComponent } from './job/job-details/job-details.component';
import { CopilotComponent } from './copilot/copilot.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      dashboardCheck: true,
      breadcrumb: { skip: true }
    }
  },
{
  path: 'copilot',
  component: CopilotComponent,
  canActivate: [AuthGuard],
  data: {
    breadcrumb: { alias: 'copilot', label: 'AI Copilot' }
  }
},

  {
    path: 'events',
    data: {
      privilege: ['event.view', 'event.create'],
      breadcrumb: { alias: 'manageEvents', label: 'Events' }
    },
    children: [
      {
        path: '',
        component: EventsListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ':eventId',
        component: CandidateListComponent,
        canActivate: [AuthGuard],
        data: {
          privilege: 'event_candidate.view',
          breadcrumb: { alias: 'eventDetails' }
        }
      }
    ]
  },

  {
    path: 'jitsiContainer',
    component: JitsiContaineComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'event_interview.join',
      breadcrumb: { alias: 'jitsi', label: 'Interview' }
    }
  },

  {
    path: 'events/:eventId',
    component: CandidateListComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'event_candidate.view',
      breadcrumb: { alias: 'eventDetails' }
    }
  },
  

  {
    path: 'users',
    component: UserListComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: ['user.view', 'user.create'],
      breadcrumb: { alias: 'users', label: 'Users' }
    }
  },

  {
    path: 'email-template',
    component: EmailTemplateComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: ['email_template.view', 'email_template.create'],
      breadcrumb: { alias: 'emailTemplate', label: 'Email Templates' }
    }
  },

  {
    path: 'roles',
    data: {
      privilege: ['job_role.view', 'job_role.create'],
      breadcrumb: { alias: 'roles', label: 'Job Roles' }
    },
    children: [
      {
        path: '',
        component: RoleListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ':roleId',
        component: JobDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          privilege: 'job_role.view',
          breadcrumb: { alias: 'roleDetail' }
        }
      }
    ]
  },  

  {
    path: 'roles/:roleId',
    component: JobDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'job_role.view',
      breadcrumb: { alias: 'roleDetail', label: 'Role Details' }
    }
  },

  {
    path: 'candidates',
    component: TalentpoolManagementComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: ['candidate.view', 'candidate.invite'],
      breadcrumb: { alias: 'talentpool', label: 'Candidates' }
    }
  },

  {
    path: 'form/:form_type',
    loadComponent: () => import("./form-builder/form-preview-v2/form-preview-v2.component").then((m) => m.FormPreviewV2Component),
    data: {
      breadcrumb: { alias: 'formReg', label: 'Registration Form' },
      preview: false,
    }
  },

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
    data: {
      breadcrumb: { alias: 'login', label: 'Login' }
    }
  },

  {
    path: 'forgotPassword',
    component: ForgetPasswordComponent,
    canActivate: [LoginGuard],
    data: {
      breadcrumb: { alias: 'forgotPassword', label: 'Forgot Password' }
    }
  },

  {
    path: 'reset-password',
    component: ForgetPasswordComponent,
    canActivate: [LoginGuard],
    data: {
      breadcrumb: { alias: 'resetPassword', label: 'Reset Password' }
    }
  },

  {
    path: 'candidatePanel',
    component: CandidatePanelComponent,
    data: {
      breadcrumb: { alias: 'candidatePanel', label: 'Candidate Panel' }
    }
  },

  {
    path: 'settings',
    component: GeneralSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: { alias: 'generalSettings', label: 'Settings' }
    }
  },

  {
    path: 'forms',
    component: FormsListComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'form_builder.view',
      breadcrumb: { alias: 'forms', label: 'Forms' }
    }
  },

  {
    path: 'forms/create',
    component: FormCreationComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'form_builder.create',
      breadcrumb: { alias: 'formCreate', label: 'Create Form' }
    }
  },

  {
    path: 'forms/view',
    loadComponent: () => import("./form-builder/form-preview-v2/form-preview-v2.component").then((m) => m.FormPreviewV2Component),
    canActivate: [AuthGuard],
    data: {
      privilege: 'form_builder.view',
      breadcrumb: { alias: 'formPreview', label: 'Form Preview' },
      preview: true
    }
  },

  {
    path: 'verification',
    component: OtpVerificationComponent,
    data: {
      breadcrumb: { alias: 'verification', label: 'Verification' }
    }
  },
  {
    path: 'assessment/:shortCode',
    component: OtpVerificationComponent,
    data: {
      breadcrumb: { alias: 'assessment', label: 'Assessment' }
    }
  },
  { path: 'sso/callback', component: LoginCallbackComponent },

  { path: 'logout', redirectTo: '/login', pathMatch: 'full' },

  {
    path: 'feedback-form',
    component: FeedbackFormComponent,
    canActivate: [AuthGuard],
    data: {
      privilege: 'event_interview.join',
      breadcrumb: { alias: 'feedback', label: 'Feedback Form' }
    }
  },

  {
    path: 'error',
    component: ErrorPageComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: { alias: 'error', label: 'Error' }
    }
  },
  {
    path: "reports",
    canActivate: [AuthGuard],
    loadComponent: () => import("./reports/reports.component").then((c) => c.ReportsComponent),
    data: {
      privilege: ['report.view'],
      breadcrumb: { alias: 'reports', label: 'Reports' }
    }
  },
  {
    path: 'interview-insights',
    loadComponent: () => import("./job/interview-insights/interview-insights.component").then((c) => c.InterviewInsightsComponent),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: { alias: 'interview-insights', label: 'Interview Analysis' }
    }
  },

  {
    path: 'ai-interview/session',
    loadComponent: () => import('./ai-interview/ai-interview.component')
      .then(m => m.AiInterviewComponent),
    data: {
      breadcrumb: { alias: 'aiInterviewSession', label: 'AI Interview' }
    }
  },

  { path: '**', redirectTo: '/error' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

